/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EnumSelectField } from './EnumSelectField';
import {
  FINISH_STANDARDS,
  LOCATION_QUALITIES,
  OCCUPANCIES,
  PROPERTY_CONDITIONS,
} from './schema';
import type { PropertyFormValues } from './schema';

interface ConditionFieldsProps {
  form: UseFormReturn<PropertyFormValues>;
}

/**
 * Condition, occupancy, finish standard and location quality: four optional
 * selects of English keys, labelled in the user's language.
 *
 * @param props - The property drawer form.
 * @returns The condition selects.
 */
export function ConditionFields({ form }: ConditionFieldsProps) {
  const { t } = useTranslation('features/properties');
  return (
    <div className="mt-(--space-4) grid grid-cols-1 gap-(--space-3) sm:grid-cols-2" data-testid="condition-fields">
      <EnumSelectField form={form} name="condition" label={t('propertyDrawer.conditions.condition')}
        options={PROPERTY_CONDITIONS} labelPrefix="form.options.condition" />
      <EnumSelectField form={form} name="occupancy" label={t('propertyDrawer.conditions.occupancy')}
        options={OCCUPANCIES} labelPrefix="form.options.occupancy" />
      <EnumSelectField form={form} name="finish_standard" label={t('propertyDrawer.conditions.finishStandard')}
        options={FINISH_STANDARDS} labelPrefix="form.options.finishStandard" />
      <EnumSelectField form={form} name="location_quality" label={t('propertyDrawer.conditions.locationQuality')}
        options={LOCATION_QUALITIES} labelPrefix="form.options.locationQuality" />
    </div>
  );
}
